import {observer} from "mobx-react-lite";
import {CvvCategoryHeader} from "../components/headers";
import {CvvInputField} from "../components/input";
import {CvvTextInput} from "../components/text_input";
import {ContentUnitFrame} from "../../components/dialogs";
import {FormStepContainer} from "../components/decorations";
import {useContext, useMemo} from "react";
import {useTheme} from "styled-components";
import {Theme} from "../../theme";
import {MladiVoznikStoreContext} from "./form_mladi_voznik";
import {MladiVoznikStore} from "../../stores/mladi_voznik_store";
import {ReactComponent as NextSvg} from "../../assets/next.svg";
import {CvvButton} from "../../components/buttons";
import {CvvRadio} from "../../components/radio";
import {cvv_types, mladi_voznik} from "../../proto/compiled";
import {CvvCollapsible} from "../../components/collapsible";
import {FormStoreContext} from "../../index";
import {FormStore} from "../../stores/form_store";
import {PricelistItems, PricelistModifiers} from "../pricelist";

export const FormMladiVoznikS4 = observer((props: any) => {
  const store = useContext(MladiVoznikStoreContext) as MladiVoznikStore;
  const formStore = useContext(FormStoreContext) as FormStore;

  const theme = useTheme() as Theme;

  const boClan = useMemo(() => {
    const value = !!store.step1.result?.jeClan || !!store.form.step4?.clanstvo;
    if (value) {
      // ce bo clan, potem je kosilo brezplacno in vedno vkljuceno
      store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.da;
    }
    return value;
  }, [store.step1.result?.jeClan, store.form.step4?.clanstvo]);

  return <FormStepContainer>
    {store.config.s4?.najemVozila && <><CvvCategoryHeader style={{marginTop: '52px'}}>
      VOZILO
    </CvvCategoryHeader>
      {!!store.form.prijatelj?.length && <ContentUnitFrame style={{padding: '16px'}}>
        <theme.textTheme.body.span>
          Vozilo je že plačal {store.form.prijatelj}.
        </theme.textTheme.body.span>
      </ContentUnitFrame>}
      {!store.form.prijatelj?.length && <>
        <CvvRadio name={'vozilo'} id={'svoje'} checked={store.form.step4?.vozilo === cvv_types.Vozilo.svoje}
                  onChange={() => {
                    store.form.step4!.vozilo = cvv_types.Vozilo.svoje;
                  }} label={'Tečaja se bom udeležil s svojim vozilom: (0,00 €)'}/>
        <CvvRadio name={'vozilo'} id={'najeto'} checked={store.form.step4?.vozilo === cvv_types.Vozilo.najeto}
                  onChange={() => {
                    store.form.step4!.vozilo = cvv_types.Vozilo.najeto;
                  }} label={'Vozilo želim najeti: ('
          + formStore.pricelist?.getPriceEur(PricelistItems.vozilo)
          + ')'}/>
        {store.config.s4?.najemVozilaSPrijateljem && <CvvRadio name={'vozilo'} id={'najeto-prijatelj'}
                                                               checked={store.form.step4?.vozilo === cvv_types.Vozilo.najeto_prijatelj}
                                                               onChange={() => {
                                                                 store.form.step4!.vozilo = cvv_types.Vozilo.najeto_prijatelj;
                                                               }}
                                                               label={'Vozilo želim najeti s prijateljem: ('
                                                                 + formStore.pricelist?.getPriceEur(PricelistItems.vozilo, [PricelistModifiers.vozilo_s_prijateljem])
                                                                 + ')'}/>}
        <div style={{
          marginTop: store.form.step4?.vozilo === cvv_types.Vozilo.najeto_prijatelj ? '-8px' : '0',
          marginBottom: store.form.step4?.vozilo === cvv_types.Vozilo.najeto_prijatelj ? '16px' : '0',
          width: "100%",
          transition: 'all 300ms',
          overflow: 'hidden'
        }}>
          <CvvCollapsible expanded={store.form.step4?.vozilo === cvv_types.Vozilo.najeto_prijatelj}>
            <ContentUnitFrame style={{padding: '16px'}}>
              <theme.textTheme.body.span>
                Avto si boste na tečaju delili s prijateljem. Vsak od vaju za najem avta plača {formStore.pricelist?.getPriceEur(PricelistItems.vozilo, [PricelistModifiers.vozilo_s_prijateljem])}. Če se vaš
                prijatelj na tečaj ne bo prijavil ali ne bo izbral te možnosti glede najema avta, boste na dan tečaja v
                našem centru doplačali {formStore.pricelist?.getModifierDifferenceEur(PricelistItems.vozilo, [PricelistModifiers.vozilo_s_prijateljem])}.
              </theme.textTheme.body.span>
              <CvvInputField label={'IME IN PRIIMEK PRIJATELJA, S KATERIM ŽELITE NAJETI AVTO'} error={store.validators.step4.voziloPrijateljIme()}
                             input={
                               <CvvTextInput
                                 invalid={!!store.validators.step4.voziloPrijateljIme()}
                                 value={store.form.step4!.voziloPrijateljIme!}
                                 onChange={(e) => store.form.step4!.voziloPrijateljIme = e.target.value.toUpperCase()}
                                 {...store.form.step4?.vozilo !== cvv_types.Vozilo.najeto_prijatelj && {tabIndex: -1}}
                               />
                             }/>
            </ContentUnitFrame>
          </CvvCollapsible>
        </div>
        {store.config.s4?.najemVozilaZDrugoOsebo && <CvvRadio name={'vozilo'} id={'najeto-drugi'}
                                                              checked={store.form.step4?.vozilo === cvv_types.Vozilo.najeto_druga_oseba}
                                                              onChange={() => {
                                                                store.form.step4!.vozilo = cvv_types.Vozilo.najeto_druga_oseba;
                                                              }}
                                                              label={'Vozilo želim najeti z drugo osebo ('
                                                                + formStore.pricelist?.getPriceEur(PricelistItems.vozilo, [PricelistModifiers.vozilo_z_drugim])
                                                                + ')'}/>}
      </>}
    </>}
    {store.config.s4?.najemVozilaCategory && <><CvvCategoryHeader style={{marginTop: '52px'}}>
      KATEGORIJA VOZILA
    </CvvCategoryHeader>
      <CvvRadio name={'vozilo-category'} id={'a1'} checked={store.form.step4?.najemVozilaCategory === mladi_voznik.NajemVozilaCategory.a1 || store.form.step4?.najemVozilaCategory === mladi_voznik.NajemVozilaCategory.none}
                onChange={() => {
                  store.form.step4!.najemVozilaCategory = mladi_voznik.NajemVozilaCategory.a1;
                }} label={'A kategorija'}/>
      <CvvRadio name={'vozilo-category'} id={'a2'} checked={store.form.step4?.najemVozilaCategory === mladi_voznik.NajemVozilaCategory.a2}
                onChange={() => {
                  store.form.step4!.najemVozilaCategory = mladi_voznik.NajemVozilaCategory.a2;
                }} label={'A2 kategorija'}/>
    </>}
    {store.config.s4?.vSkupiniSPrijateljem && !store.form.prijatelj?.length &&
        <CvvCollapsible expanded={store.form.step4?.vozilo !== cvv_types.Vozilo.najeto_prijatelj}>
          <CvvCategoryHeader style={{marginTop: '52px'}}>
            V SKUPINI ŽELIM BITI S PRIJATELJEM
          </CvvCategoryHeader>
          <CvvRadio
              tabIndex={store.form.step4!.vozilo === cvv_types.Vozilo.najeto_prijatelj ? -1 : undefined}
              name={'prijatelj'} id={'da'} checked={store.form.step4!.vSkupiniSPrijateljem!} onChange={() => {
            store.form.step4!.vSkupiniSPrijateljem = true;
          }} label={'da'}/>
          <CvvRadio
              tabIndex={store.form.step4!.vozilo === cvv_types.Vozilo.najeto_prijatelj ? -1 : undefined}
              name={'prijatelj'} id={'ne'} checked={!store.form.step4!.vSkupiniSPrijateljem} onChange={() => {
            store.form.step4!.vSkupiniSPrijateljem = false;
          }} label={'ne'}/>
          <CvvCollapsible expanded={!!store.form.step4!.vSkupiniSPrijateljem}>
            <CvvInputField error={store.validators.step4.skupinaPrijateljIme()}
                           label={'IME IN PRIIMEK PRIJATELJA'}
                           input={
                             <CvvTextInput
                                 invalid={!!store.validators.step4.skupinaPrijateljIme()}
                                 value={store.form.step4!.skupinaPrijateljIme!}
                                 onChange={(e) => store.form.step4!.skupinaPrijateljIme = e.target.value.toUpperCase()}
                                 {...!store.form.step4?.vSkupiniSPrijateljem && {tabIndex: -1}}
                             />
                           }/>
          </CvvCollapsible>
        </CvvCollapsible>}

    {store.config.s4?.skleniClanstvo && !store.step1.result?.jeClan && <>
        <CvvCategoryHeader style={{marginTop: '52px'}}>
            Skleni AMZS članstvo in prejmi brezplačno kosilo
        </CvvCategoryHeader>
        <CvvRadio name={'clanstvo'} id={'da'} checked={store.form.step4!.clanstvo!}
                  onChange={() => {
                      store.form.step4!.clanstvo = true;
                  }} label={'da ('
            + formStore.pricelist?.getPriceEur(PricelistItems.clanstvo, Array.from(store.pricelistModifiers))
            + ')'}/>
        <CvvRadio name={'clanstvo'} id={'ne'} checked={!store.form.step4!.clanstvo} onChange={() => {
            store.form.step4!.clanstvo = false;
            store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.ne;
        }} label={'ne'}/>
    </>}

    {store.config.s4?.eIzpitKoda &&
        <CvvInputField label={'E-IZPIT KODA'} input={
          <CvvTextInput value={store.form.step4!.eIzpitKoda!}
                        onChange={(e) => store.form.step4!.eIzpitKoda = e.target.value}/>
        }/>}


    {store.config.s4?.kosilo && <><CvvCategoryHeader style={{marginTop: '52px'}}>
      Kosilo
    </CvvCategoryHeader>
      <ContentUnitFrame style={{padding: '16px', marginTop: '-10px', marginBottom: '8px'}}>
        <theme.textTheme.button.span>Kosilo (glavna jed, solata, sladica) ni vključeno v ceno tečaja, je pa
          brezplačno za člane AMZS. Brezplačno kosilo vam pripada tudi, če svojo vožnjo na tečaj posnamete z
          aplikacijo DRAJV.
        </theme.textTheme.button.span>
      </ContentUnitFrame>
      {!boClan && <>
        <CvvRadio name={'kosilo'} id={'da-sam'}
                  checked={store.form.step4!.kosiloMultipleChoice === mladi_voznik.Kosilo.da}
                  onChange={() => {
                    store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.da;
                  }}
                  label={'Kosilo plačam sam (' + formStore.pricelist?.getPriceEur(PricelistItems.kosilo, Array.from(store.pricelistModifiersWithoutClanstvo)) + ')'}/>
        {store.formStore?.formConfig?.s4?.kosiloBoClan &&
            <CvvRadio name={'kosilo'} id={'da-boClan'}
                      checked={store.form.step4!.kosiloMultipleChoice === mladi_voznik.Kosilo.da_bo_clan}
                      onChange={() => {
                        store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.da_bo_clan;
                      }}
                      label={'Želim kosilo – do tečaja bom sklenil AMZS članstvo'}/>}
        {store.formStore?.formConfig?.s4?.kosiloDrajv &&
            <CvvRadio name={'kosilo'} id={'da-drive'}
                      checked={store.form.step4!.kosiloMultipleChoice === mladi_voznik.Kosilo.da_drajv}
                      onChange={() => {
                        store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.da_drajv;
                      }} label={'Želim kosilo – kosilo časti DRAJV'}/>}
        <CvvRadio name={'kosilo'} id={'ne'} checked={store.form.step4!.kosiloMultipleChoice === mladi_voznik.Kosilo.ne}
                  onChange={() => {
                    store.form.step4!.kosiloMultipleChoice = mladi_voznik.Kosilo.ne;
                  }} label={'Ne želim kosila'}/></>}</>}

    {store.config.s4?.opomba && <>
      <div style={{marginTop: '32px'}}/>
      <CvvInputField label={'OPOMBE'} input={
        <CvvTextInput
            value={store.form.step4!.opomba ?? ''}
            onChange={(e) => store.form.step4!.opomba = e.target.value}/>
      }/>
    </>}

    {store.config.s6?.kjeSteSlisaliZaNas && <>
      <div style={{marginTop: '32px'}}/>
      <CvvInputField label={'KJE STE SLIŠALI ZA NAS?'} input={
        <CvvTextInput
            value={store.form.step6?.kjeSteSlisaliZaNas ?? ''}
            onChange={(e) => store.form.step6!.kjeSteSlisaliZaNas = e.target.value}/>
      }/>
    </>}

    {store.config.s6?.nacinKontaktiranja && <>
      <div style={{marginTop: '32px'}}/>
      <CvvInputField label={'NAČIN KONTAKTIRANJA'} input={
        <CvvTextInput
            value={store.form.step6?.nacinKontaktiranja ?? ''}
            onChange={(e) => store.form.step6!.nacinKontaktiranja = e.target.value}/>
      }/>
    </>}

    {store.config.s6?.promocijskaKoda && <>
      <div style={{marginTop: '32px'}}/>
      <CvvInputField label={`PROMOCIJSKA KODA${store.config.s6?.promocijskaKodaTekst ? ` (${store.config.s6.promocijskaKodaTekst})` : ''}`} input={
        <CvvTextInput
            value={store.form.step6?.promoCode ?? ''}
            onChange={(e) => store.form.step6!.promoCode = e.target.value}/>
      }/>
    </>}

    <CvvButton
        onClick={() => store.setStep(store.step + 1)}
        style={{marginTop: '64px'}}
        disabled={!store.stepValid(store.step, false)}>
      <theme.textTheme.headline5.span>NAPREJ</theme.textTheme.headline5.span>
      <NextSvg height={'22px'} style={{marginLeft: 'auto'}}/>
    </CvvButton>
  </FormStepContainer>
})